<template>

  <v-dialog  fullscreen  scrollable   v-model="history.infModal">



      <v-card>
        <v-toolbar color="#273C51" dark   flat  height="42">
          <v-icon @click="getInfo()">mdi-content-save</v-icon>
          <v-toolbar-title  >  Процесс:  "{{history.selectedProc.title}}"  </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="history.infModal = false">mdi-close</v-icon>
        </v-toolbar>

         <v-card-text style="height:100vh" scrollable>

<v-layout row wrap justify-center  >


<!-- общая информация -->
<v-card style="margin:5px;width:650px">
<v-toolbar     flat  height="42">
<v-toolbar-title  >
<v-list two-line dense>
<v-list-tile-content>
<v-list-tile-title>Общая информация</v-list-tile-title>
<v-list-tile-sub-title><span style="color:#273C51">#</span>{{fullInfo.proc_id}}</v-list-tile-sub-title>
</v-list-tile-content>
</v-list>
</v-toolbar-title>

<v-spacer/>
<v-btn color="green" small flat><v-icon left small>mdi-content-save</v-icon><span style="text-transform:none">Сохранить изменения</span></v-btn>
</v-toolbar>

<v-card-text>

<p style="color:#757575;font-size:1.3em"> Через какое время обновлять процесс ?</p>
<v-layout row>
    <v-flex class="px-3">
      <v-subheader>Минуты</v-subheader>
      <v-slider
      v-model="updateTimer.min"
      max="59"
      color="primary"
      thumb-label="always"
      ></v-slider>
      </v-flex>


     <v-flex class="px-3">
       <v-subheader>Часы</v-subheader>
      <v-slider
      v-model="updateTimer.hours"
      max="23"
      color="primary"
      thumb-label="always"
      ></v-slider>
      </v-flex>


     <v-flex class="px-3">
       <v-subheader>Дни</v-subheader>
      <v-slider
      max="30"
      v-model="updateTimer.days"
      color="primary"
      thumb-label="always"
      ></v-slider>
      </v-flex>
</v-layout>




<v-layout row wrap justify-center  v-if="da">
    <v-card flat style="margin:10px">
      <v-toolbar     flat  height="42">
        <v-toolbar-title  >  Параметры процесса  </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <div  >

    <v-text-field label="Поисковая строка" value="Маша петрова, егор беляев, дмитрий черноговор">
    </v-text-field>

    <v-textarea label="Параметры VK API" value="Маша петрова, егор беляев, дмитрий черноговор">
    </v-textarea>


        </div>
      </v-card-text>
    </v-card>

    <v-card  flat style="margin:10px">
      <v-toolbar     flat  height="42">
        <v-toolbar-title  >  Зависимые процессы   </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
    <div >
     Зависмых процессов нет
    </div>
      </v-card-text>
    </v-card>
</v-layout  >



</v-card-text>
</v-card>
<!-- общая информация Закрытие -->



<!-- История обновлений -->
<v-card style="width:450px;margin:10px">
  <v-toolbar     flat  height="42">
    <v-icon>mdi-update</v-icon>
    <v-toolbar-title  >  История обновлений   </v-toolbar-title>

  </v-toolbar>

  <v-card-text>

<div v-for="item in fullInfo.updated_diff">
  <v-layout>
<v-btn  disabled flat block small><span style="color:gray">{{item.time|dateFormat}}</span></v-btn>
<v-btn @click="openResults(item.new_in, 'Входящий трафик',item.time)" color="green" flat small><v-icon left>mdi-plus</v-icon> {{item.new_in.length}} <v-spacer></v-spacer> </v-btn>
<v-btn @click="openResults(item.new_out, 'Исходящий трафик',item.time)" color="red" flat small><v-icon left>mdi-minus</v-icon>{{item.new_out.length}} <v-spacer></v-spacer> </v-btn>
</v-layout>
<v-divider></v-divider>
</div>



  </v-card-text>
</v-card>

<v-dialog v-model="results.modal" scrollable width="900" persistent  fullheight>
<procUpdateData :results="results"></procUpdateData>
</v-dialog>
<!-- История обновлений  закрытие -->


</v-layout>






         </v-card-text>

         <v-divider></v-divider>


       </v-card>

  </v-dialog>





</template>

<script>

import axios from 'axios'
import procUpdateData from './procUpdateData.vue'
export default {
components: {procUpdateData},
props:['history'],
  data () {
    return {
da: false,  // просто лишнее

updateTimer:{
  min:5,
  hours:3,
  days:2,
},

results:{
  loadingMore:false,
  modal:false,
  procInfo: {},   // информация о процессе результаты которого просматриваются
  contentType: "",
  foundData:{
   selector: false,
   foundIds: [],
   displayIds: [],
   selectedIds: [],
   offset: 0,
   selectAll: false
 },


 pagesContentMenegment: {
   snackbarAbsoute: true,
   items: {
     selector: {active:true},
     copy: {active:true},
     export: {active:true},
     update: {active:false},
     delete: {active:false},
     autoExport: {active:false}
   },
   contentInfo: {
     type: 'pages',
   },
   autoExport: {
     isActive: false,
     tasksList:[],
  },


},

},



fullInfo:{}
    }
  },

methods:{
openResults(data,trafType,time){
  console.log(this.history)
  this.results.pagesContentMenegment.contentInfo.type = this.history.selectedProc.content_type
  this.results.procInfo.title = this.dateFormats(time)+" - "+trafType
  this.results.foundData.foundIds = data
  this.results.modal = true
},

getInfo(){
  axios.post('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/get_proc_info.php',{
    data:{
      process_id : this.history.selectedProc.process_id
    }
  })
  .then(response=>{
    this.fullInfo =  response.data
  })
},
dateFormats(item){
  var months = ['Янв.','Фев.','Мар.','Апр.','Май.','Июня','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];
  let d =  new Date(item * 1000)
  return  d.getDate()+" "+months[d.getMonth()]+" в "+ d.getHours() +":"+ d.getMinutes()
}
},
computed: {

},
filters:{

  dateFormat(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Май.','Июня','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];
    let d =  new Date(item * 1000)
    return  d.getDate()+" "+months[d.getMonth()]+" в "+ d.getHours() +":"+ d.getMinutes()
  }
},
created(){
  this.getInfo()
},
}
</script>

<style  >

</style>
